'use client';

import { c as _c } from "react/compiler-runtime";
import { PARAMS_KEY_CONVERSATION_ID, PARAMS_KEY_INTERACTION_ID } from '@/constants/route-params-keys';
import { createContext, PropsWithChildren, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { useProjectsContext } from '@/providers/projects-provider';
import { getDeepLinkScopedStorageKeys, resolveDeepLinkState } from '@/utils/deep-link.utils';
type DeepLinkType = 'conversation' | 'interaction' | null;
type DeepLinkContextValue = {
  deepLinkConversationId: string | null;
  deepLinkInteractionId: string | null;
  deepLinkType: DeepLinkType;
  isDeepLink: boolean;
  setDeepLinkConversationId: (id: string | null) => void;
  setDeepLinkInteractionId: (id: string | null) => void;
};
const DeepLinkContext = createContext<DeepLinkContextValue | null>(null);
export function DeepLinkProvider(t0) {
  const $ = _c(28);
  const {
    children
  } = t0;
  const searchParams = useSearchParams();
  const {
    organizationId,
    projectId
  } = useProjectsContext();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get(PARAMS_KEY_CONVERSATION_ID);
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const urlConversationId = t1;
  let t2;
  if ($[2] !== searchParams) {
    t2 = searchParams.get(PARAMS_KEY_INTERACTION_ID);
    $[2] = searchParams;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const urlInteractionId = t2;
  const storageScope = `${organizationId ?? "no-org"}:${projectId ?? "no-project"}`;
  let t3;
  if ($[4] !== storageScope) {
    t3 = getDeepLinkScopedStorageKeys(storageScope);
    $[4] = storageScope;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    conversationKey: conversationStorageKey,
    interactionKey: interactionStorageKey
  } = t3;
  const [deepLinkConversationId, setDeepLinkConversationIdState] = useState(null);
  const [deepLinkInteractionId, setDeepLinkInteractionIdState] = useState(null);
  let t4;
  if ($[6] !== conversationStorageKey || $[7] !== interactionStorageKey) {
    t4 = id => {
      setDeepLinkConversationIdState(id);
      setDeepLinkInteractionIdState(null);
      if (typeof window === "undefined") {
        return;
      }
      if (id) {
        window.sessionStorage.setItem(conversationStorageKey, id);
      } else {
        window.sessionStorage.removeItem(conversationStorageKey);
      }
      window.sessionStorage.removeItem(interactionStorageKey);
    };
    $[6] = conversationStorageKey;
    $[7] = interactionStorageKey;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const setDeepLinkConversationId = t4;
  let t5;
  if ($[9] !== conversationStorageKey || $[10] !== interactionStorageKey) {
    t5 = id_0 => {
      setDeepLinkInteractionIdState(id_0);
      setDeepLinkConversationIdState(null);
      if (typeof window === "undefined") {
        return;
      }
      if (id_0) {
        window.sessionStorage.setItem(interactionStorageKey, id_0);
      } else {
        window.sessionStorage.removeItem(interactionStorageKey);
      }
      window.sessionStorage.removeItem(conversationStorageKey);
    };
    $[9] = conversationStorageKey;
    $[10] = interactionStorageKey;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const setDeepLinkInteractionId = t5;
  let t6;
  let t7;
  if ($[12] !== conversationStorageKey || $[13] !== interactionStorageKey || $[14] !== urlConversationId || $[15] !== urlInteractionId) {
    t6 = () => {
      if (typeof window === "undefined") {
        return;
      }
      const storedConversationId = window.sessionStorage.getItem(conversationStorageKey);
      const storedInteractionId = window.sessionStorage.getItem(interactionStorageKey);
      const resolved = resolveDeepLinkState({
        urlInteractionId,
        urlConversationId,
        storedInteractionId,
        storedConversationId
      });
      setDeepLinkInteractionIdState(resolved.interactionId);
      setDeepLinkConversationIdState(resolved.conversationId);
      if (resolved.interactionId) {
        window.sessionStorage.setItem(interactionStorageKey, resolved.interactionId);
        window.sessionStorage.removeItem(conversationStorageKey);
        return;
      }
      if (resolved.conversationId) {
        window.sessionStorage.setItem(conversationStorageKey, resolved.conversationId);
        window.sessionStorage.removeItem(interactionStorageKey);
        return;
      }
      window.sessionStorage.removeItem(conversationStorageKey);
      window.sessionStorage.removeItem(interactionStorageKey);
    };
    t7 = [conversationStorageKey, interactionStorageKey, urlConversationId, urlInteractionId];
    $[12] = conversationStorageKey;
    $[13] = interactionStorageKey;
    $[14] = urlConversationId;
    $[15] = urlInteractionId;
    $[16] = t6;
    $[17] = t7;
  } else {
    t6 = $[16];
    t7 = $[17];
  }
  useEffect(t6, t7);
  let t8;
  bb0: {
    if (deepLinkInteractionId) {
      t8 = "interaction";
      break bb0;
    }
    if (deepLinkConversationId) {
      t8 = "conversation";
      break bb0;
    }
    t8 = null;
  }
  const deepLinkType = t8;
  const t9 = !!deepLinkType;
  let t10;
  if ($[18] !== deepLinkConversationId || $[19] !== deepLinkInteractionId || $[20] !== deepLinkType || $[21] !== setDeepLinkConversationId || $[22] !== setDeepLinkInteractionId || $[23] !== t9) {
    t10 = {
      deepLinkConversationId,
      deepLinkInteractionId,
      deepLinkType,
      isDeepLink: t9,
      setDeepLinkConversationId,
      setDeepLinkInteractionId
    };
    $[18] = deepLinkConversationId;
    $[19] = deepLinkInteractionId;
    $[20] = deepLinkType;
    $[21] = setDeepLinkConversationId;
    $[22] = setDeepLinkInteractionId;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const value = t10;
  let t11;
  if ($[25] !== children || $[26] !== value) {
    t11 = <DeepLinkContext.Provider value={value}>{children}</DeepLinkContext.Provider>;
    $[25] = children;
    $[26] = value;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
}
export function useDeepLinkContext() {
  const context = useContext(DeepLinkContext);
  if (!context) {
    throw new Error("useDeepLinkContext must be used within a DeepLinkProvider");
  }
  return context;
}